import React from 'react';
import Gabmap from './Gabmap';
import './App.css';

function App() {
  return (
    <div className="App">
      <Gabmap />
    </div>
  );
}

export default App;
